import React, { useEffect, useState } from 'react'
import ContainerBox from '../components/ContainerBox'
import { I18n } from 'react-redux-i18n'
import SwitchControl from '../components/SwitchControl'
import TimerSelector from 'components/common/TimerSelector'
import { useDispatch, useSelector } from 'react-redux'
import TimeAndDate from 'utils/TimeAndDate'
import operatorDisabledAction from 'redux/operatorAutoDisabled/actions'

const AutomationInactiveOperators = () => {
  const { operatorAutoDisabled: { isActive, unit, time } } = useSelector(state => state)
  const [errorMessage, setErrorMessage] = useState('')
  const dispatch = useDispatch()
  const isAllParameters = isActive !== undefined && unit !== undefined && time !== undefined ? true : false
  const valuesTimer = TimeAndDate.millisecondsToUnit({
    unit,
    time
  })
  useEffect(() => {
    if(!isAllParameters){
      dispatch(operatorDisabledAction.setOperatorDisabled({
        isActive: false,
        unit: 'months',
        time: TimeAndDate.timeToMilliseconds({ unit: 'months', time: 1 }).time
      }))
    }
  }, [])

  const onChange = (value) => {
    setErrorMessage('')
    if(typeof value === 'boolean'){
      dispatch(operatorDisabledAction.setOperatorDisabled({
        isActive: value,
        unit,
        time
      }))
    } else {
      const { time, unit } = value.value
      if(unit === 'days' && time < 7) setErrorMessage(I18n.t('dashboard_error-message-operator-disabled'))
      if(unit === 'months' && time < 1) setErrorMessage(I18n.t('dashboard_error-message-operator-disabled-month'))
      const timeConvert = TimeAndDate.timeToMilliseconds({ unit: unit, time: time })
      dispatch(operatorDisabledAction.setOperatorDisabled({
        isActive,
        unit: timeConvert.unit,
        time: timeConvert.time
      }))
    }
  }

  return (
    <ContainerBox
      title={I18n.t(`dashboard_deactivation_inactive_operators`)}
    >
      <SwitchControl
        value={isAllParameters ? isActive : false}
        onChange={onChange}
      />
      <TimerSelector
        label={I18n.t('dashboard_inactivityTime')}
        value={{
          time: Math.round(valuesTimer.time),
          unit: valuesTimer.unit
        }}
        onChange={value => onChange({ type: 'timer', value })}
        exclude={['seconds', 'hours', 'minutes']}
      />
      {errorMessage ? (
        <p className='message-error'>{errorMessage}</p>
      ) : null}
    </ContainerBox>
  )
}

export default AutomationInactiveOperators